import { useState } from "react";
import { useEffect } from "react";
import Footer from "./Footer";
import "./styles/About.css";
import Header from "./Header";
import { animate, motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";

const reviews = [
  {
    name: "Ivan",
    country: "Srbija",
    comment:
      "Čist, udoban apartman na odličnoj lokaciji. Ima sve što vam je potrebno i za kraći i za duži boravak. Komunikacija sa vlasnicima perfektna. Sve pohvale za ovaj apartman, rado ću opet boraviti kada budem dolazio na Zlatiboru.",
    date: "Januar 2025",
  },
  {
    name: "Sonja",
    country: "Srbija",
    comment:
      "Smeštaj je za svaku pohvalu - lokacija idealna, u tihom delu, a blizu centra, čisto, udobno, toplo, opremljeno do svakog detalja. Domaćini izuzetno predusretljivi i ljubazni. Definitivno ćemo doći ponovo!",
    date: "Oktobar 2024",
  },
  {
    name: "Nevena",
    country: "Srbija",
    comment:
      "Apartman je na dobroj lokaciji, cena je takodje veoma pristupačna, domaćini su veoma ljubazni, apartman izgleda potpuno isto kao i na slikama, takodje sve je bilo uredno i čisto.",
    date: "Avgust 2024",
  },
  {
    name: "Dragan",
    country: "Srbija",
    comment:
      "Lak dogovor,izuzetna gostoljubivost, higijena na visokom nivou,odlična lokacija,pravo mesto za porodicu,sve pohvale i preporuke!!!",
    date: "Avgust 2024",
  },
  {
    name: "Krstic",
    country: "Srbija",
    comment:
      "Sve je bilo savršeno. Apartman kao i na slikama izuzetno čist za svaku pohvalu.Srdacno smo dočekani isto tako i ispraćeni.Kada se bude kazala prilika bićemo rado vaši gosti.Pozdrav.",
    date: "Mart 2025",
  },
  {
    name: "Bojan",
    country: "Srbija",
    comment:
      "Smeštaj je odlično opremljen i sadrži sve što je potrebno za ugodan boravak. Čistoća smeštaja kao i ostatka objekta je na visokom nivou.",
    date: "Decembar 2024",
  },
];

function About() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <div className="mainAboutDiv">
        <Helmet>
          <title>Apartman Stari Vlah - O našem apartmanu</title>
          <meta
            name="description"
            content="Saznajte više o Apartmanu Stari Vlah na Zlatiboru. Pročitajte o našoj udobnoj i moderno opremljenoj jedinici koja je idealna za vaš odmor na Zlatiboru."
          />
          <meta
            name="keywords"
            content="o apartmanu Zlatibor, apartman Stari Vlah Zlatibor, Zlatibor apartman informacije, smeštaj Zlatibor o nama, naš apartman Zlatibor, autentičan smeštaj Zlatibor, luksuzni apartman Zlatibor"
          />
          <meta
            property="og:title"
            content="Apartman Stari Vlah - O našem apartmanu"
          />
          <meta
            property="og:description"
            content="Upoznajte Apartman Stari Vlah na Zlatiboru. Naša prijatna i udobna jedinica pruža sve što vam je potrebno za savršen odmor."
          />
          <meta property="og:image" content="/images/logoKrug.webp" />
          <meta
            property="og:url"
            content="https://starivlahzlatibor.rs/about"
          />
        </Helmet>
        <div className="aboutMainImgDiv">
          <img
            src="/images/roomImages/kuhinja1.webp"
            className="aboutMainImg"
          />
          <motion.h1
            className="aboutNameHeader"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}
          >
            Apartman Stari Vlah
          </motion.h1>
          <motion.h2
            className="aboutMainHeader"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}
          >
            O nama
          </motion.h2>
          <motion.h3
            className="aboutMainParagraph"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}
          >
            Spoj tradicije i udobnosti – vaš idealan smeštaj na Zlatiboru, mesto u kojem 
            se toplina doma susreće sa lepotom prirode
          </motion.h3>
        </div>
        <div className="underHeaderAboutDiv">
          <motion.div
            className="leftUnderHeaderDiv"
            initial={{ x: "-100", opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <h2 className="leftDivHeader">
              Smeštaj na Zlatiboru u kojem ćete se osećati kao kod kuće
            </h2>
            <h3 className="aboutDescription1">
              🛏️ Apartman Stari Vlah predstavlja kompletno sređen i opremljen
              smeštaj za odmor na Zlatiboru, na samo 6 minuta hoda do centra
              grada.
            </h3>
            <h3 className="aboutDescription2">
              Smeštaj je potpuno opremljen svim neophodnim sadržajima, pružajući
              gostima udobnost i opušten boravak. U našem apartmanu čeka vas:
              kafa i čaj, besplatna WiFI konekcija, besplatan parking, kablovska
              televizija, čisti peškiri i posteljina, pegla i daska za peglanje,
              veš mašina, kompletno opremljena kuhinja sa šporetom, rernom i
              posuđem, kozmetika za ličnu higijenu, smart TV u dnevnoj sobi, kao
              i velika terasa savršena za jutarnju kafu. ☕
            </h3>
            <h3 className="aboutDescription3">
              Apartman je prvenstveno namenjen parovima i porodicama sa decom,
              ali i ostalima koji vole prirodu i udobnost toplog doma.
              Maksimalan kapacitet gostiju je 4. U spavaćoj sobi nalazi se
              bračni krevet, a u dnevnom boravku kauč na razvlačenje.
            </h3>
          </motion.div>
          <motion.div
            className="rightUnderHeaderDiv"
            initial={{ x: "100", opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.5 }}
          
          >
            <img
              className="leftUnderHeaderImg"
              src="/images/roomImages/terasa1.webp"
              alt="Apartman Stari Vlah Zlatibor Smestaj - Slika terase"
              loading="lazy"
            />
            <img
              className="rightUnderHeaderImg"
              src="/images/roomImages/detalj1.webp"
              alt="Apartman Stari Vlah Zlatibor Smestaj - Slika detalja"
              loading="lazy"
            />
          </motion.div>
        </div>
        <div className="aboutLocationDiv">
          <div className="locationRightDiv">
            <div className="locationAmenitiesDiv" id="locationAmenitiesDiv">
              <motion.div
                className="amenityDiv"
                initial={{ x: "-100%", opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
              >
                <img
                  src="/images/city-park.webp"
                  className="amenityIcon"
                  alt="Apartman Stari Vlah Zlatibor Smestaj - Ikona gradskog parka"
                  loading="lazy"
                />
                <p className="locationName">Kraljev trg / Centar :</p>
                <p className="locationDistance">600 metara</p>
              </motion.div>
              <motion.div
                className="amenityDiv"
                initial={{ x: "-100%", opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  delay: 0.2,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
              >
                <img
                  src="/images/grocery.webp"
                  className="amenityIcon"
                  alt="Apartman Stari Vlah Zlatibor Smestaj - Ikona prodavnice"
                  loading="lazy"
                />
                <p className="locationName">Prodavnica Maxi :</p>
                <p className="locationDistance">100 metara</p>
              </motion.div>
              <motion.div
                className="amenityDiv"
                initial={{ x: "-100%", opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  delay: 0.4,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
              >
                <img
                  src="/images/playground.webp"
                  className="amenityIcon"
                  alt="Apartman Stari Vlah Zlatibor Smestaj - Ikona dečijeg parka"
                  loading="lazy"
                />
                <p className="locationName">Dečiji park :</p>
                <p className="locationDistance">50 metara</p>
              </motion.div>
              <motion.div
                className="amenityDiv"
                initial={{ x: "-100%", opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  delay: 0.6,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
              >
                <img
                  src="/images/cable-car.webp"
                  className="amenityIcon"
                  alt="Apartman Stari Vlah Zlatibor Smestaj - Ikona gondole"
                  loading="lazy"
                />
                <p className="locationName">Gold Gondola :</p>
                <p className="locationDistance">1 kilometar</p>
              </motion.div>
              <motion.div
                className="amenityDiv"
                initial={{ x: "-100%", opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  delay: 0.8,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
              >
                <img
                  src="/images/mountain.webp"
                  className="amenityIcon"
                  alt="Apartman Stari Vlah Zlatibor Smestaj - Ikona planine"
                  loading="lazy"
                />
                <p className="locationName">Ski centar Tornik :</p>
                <p className="locationDistance">9 kilometara</p>
              </motion.div>
              <motion.div
                className="amenityDiv"
                initial={{ x: "-100%", opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  delay: 1,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
              >
                <img
                  src="/images/dino.webp"
                  className="amenityIcon"
                  alt="Apartman Stari Vlah Zlatibor Smestaj - Ikona dinosaurusa"
                  loading="lazy"
                />
                <p className="locationName">Dino park :</p>
                <p className="locationDistance">1 kilometar</p>
              </motion.div>
              <motion.div
                className="amenityDiv"
                initial={{ x: "-100%", opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  delay: 1.1,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
              >
                <img
                  src="/images/cave.webp"
                  className="amenityIcon"
                  alt="Apartman Stari Vlah Zlatibor Smestaj - Ikona pećine"
                  loading="lazy"
                />
                <p className="locationName">Stopića pećina :</p>
                <p className="locationDistance">20 kilometara</p>
              </motion.div>
              <motion.div
                className="amenityDiv"
                initial={{ x: "-100%", opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  duration: 0.6,
                  delay: 1.2,
                  ease: "easeOut",
                }}
                viewport={{ once: true }}
              >
                <img
                  src="/images/cabin.webp"
                  className="amenityIcon"
                  alt="Apartman Stari Vlah Zlatibor Smestaj - Ikona kolibe"
                  loading="lazy"
                />
                <p className="locationName">Mokra Gora :</p>
                <p className="locationDistance">40 kilometara</p>
              </motion.div>
            </div>
          </div>
          <div className="locationLeftDiv">
            <h1 className="locationMainHeader">
              Lokacija apartmana Stari Vlah na Zlatiboru
            </h1>
            <p className="locationParagraph">
              &#128205; Apartman Stari Vlah nalazi se na idealnoj lokaciji na
              Zlatiboru – u mirnoj ulici blizu centra, udaljenoj svega 6 minuta
              hoda do centra. Smešten u blizini glavnih turističkih atrakcija,
              apartman omogućava brz pristup Kraljevom trgu, Zlatiborskom
              jezeru, pijaci, restoranima i kafićima, dok istovremeno pruža mir
              i tišinu potrebnu za opuštanje.
            </p>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d342.53500026593014!2d19.701486332588345!3d43.732890805878625!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1ssr!2srs!4v1742310719213!5m2!1ssr!2srs"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="googleMap"
            ></iframe>
          </div>
        </div>
        <div className="userReviewsDiv">
          <h2 className="userReviewsHeader">RECENZIJE GOSTIJU</h2>
          <h3 className="userReviewsDescriptionHeader">
            Ovako naši gosti opisuju boravak u apartmanu
          </h3>

          <Slider key={windowWidth} {...settings} className="reviewsSlideDiv">
            {reviews.map((review, index) => (
              <div key={index} className="reviewCard">
                <p className="reviewComment">"{review.comment}"</p>
                <div className="reviewRowDiv">
                  <img
                    src="/images/logoKrug.webp"
                    className="reviewLogo"
                    alt="Apartman Stari Vlah Zlatibor Smestaj - logo"
                    loading="lazy"
                  />
                  <div className="reviewColumnDiv">
                    <h4 className="reviewNameAbout">{review.name}</h4>
                    <p className="reviewCountry">{review.country}</p>
                  </div>
                  <p className="reviewDate">{review.date}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default About;
